export default __webpack_public_path__ + "static/media/servicesSupport.de198f5d.jpg";